import { render, staticRenderFns } from "./BaseInputTel.vue?vue&type=template&id=97d98f0e"
import script from "./BaseInputTel.vue?vue&type=script&lang=js"
export * from "./BaseInputTel.vue?vue&type=script&lang=js"
import style0 from "./BaseInputTel.vue?vue&type=style&index=0&id=97d98f0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports